export default __webpack_public_path__ + "static/media/supportFallback.ed753dbb.png";